import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { getToken } from '../../../../helpers/Jwt';

const EntryCompany = () => {
    const { id } = useParams(); // perusahaan ID
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [initialValues, setInitialValues] = useState({
        name: 'x',
        company: '',
        address: '',
    });

    const [socialInitialValues, setSocialInitialValues] = useState({
        facebook: 'http',
        instagram: '',
        whatsapp: '',
    });

    useEffect(() => {
        const fetchCompany = async () => {
            try {
                const response = await axios.get(`${BASE_URL}api/rentcar/dashboard/company`, {
                    headers: {
                        'Authorization': `Bearer ${getToken()}`
                    }
                });

                const { company, address, name } = response.data;
                setInitialValues({
                    company: company || '',
                    address: address || '',
                    name: name || ''
                });

            } catch (error) {
                console.error('Gagal mengambil data perusahaan:', error);
            }
        };

        const fetchInfo = async () => {
            try {
                const response = await axios.get(`${BASE_URL}api/rentcar/dashboard/company/info`, {
                    headers: {
                        'Authorization': `Bearer ${getToken()}`
                    }
                });

                const { facebook, instagram, whatsapp } = response.data;
                
                setSocialInitialValues({
                    facebook: facebook || '',
                    instagram: instagram || '',
                    whatsapp: whatsapp || ''
                });

            } catch (error) {
                console.error('Gagal mengambil data perusahaan:', error);
            }
        };

        fetchCompany();
        fetchInfo();
    }, [BASE_URL]);

    const companySchema = Yup.object().shape({
        name: Yup.string().required('Nama Usaha wajib diisi'),
        company: Yup.string().required('Nama Perusahaan wajib diisi'),
        address: Yup.string().required('Alamat wajib diisi'),
    });

    const socialSchema = Yup.object().shape({
        instagram: Yup.string().required('Instagram wajib diisi'),
        facebook: Yup.string().required('Facebook wajib diisi'),
        whatsapp: Yup.number().required('No. Whatsapp wajib diisi'),
    });
    

    const handleCompanySubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('company', values.company);
            formData.append('address', values.address);

            await axios.post(`${BASE_URL}api/rentcar/dashboard/company`, formData, {
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                }
            });

            resetForm();
            window.location.reload();
        } catch (error) {
            console.error('Gagal menyimpan data perusahaan:', error);
        } finally {
            setSubmitting(false);
        }
    };

    const handleSocialSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const payload = {
                id: id, // dikirim sesuai dengan backend
                infos: [
                    { type: 'LINK', label: 'Facebook', value: values.facebook },
                    { type: 'LINK', label: 'Instagram', value: values.instagram },
                    { type: 'TEXT', label: 'Whatsapp', value: values.whatsapp },
                ]
            };

            await axios.post(`${BASE_URL}api/rentcar/dashboard/company/info`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });

            alert('Data social media berhasil disimpan!');
            resetForm();
        } catch (error) {
            console.error('Gagal menyimpan data social media:', error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="space-y-10">
            {/* Form Perusahaan */}
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={companySchema}
                onSubmit={handleCompanySubmit}
            >
                {({ isSubmitting }) => (
                    <Form className="space-y-4">
                        <h2 className="text-xl font-bold px-6">Informasi Perusahaan</h2>
                        <div className="grid grid-cols-1 gap-4 px-6 py-2">
                            <div>
                                <label htmlFor="name">Nama usaha</label>
                                <Field
                                    name="name"
                                    className="my-2 p-2 w-full border border-gray-300 rounded-md"
                                    type="text"
                                />
                                <ErrorMessage name="name" component="p" className="text-red-500 text-xs" />
                            </div>

                            <div>
                                <label htmlFor="company">Nama Perusahaan</label>
                                <Field
                                    name="company"
                                    className="my-2 p-2 w-full border border-gray-300 rounded-md"
                                    type="text"
                                />
                                <ErrorMessage name="company" component="p" className="text-red-500 text-xs" />
                            </div>

                            <div>
                                <label htmlFor="address">Alamat</label>
                                <Field
                                    name="address"
                                    className="my-2 p-2 w-full border border-gray-300 rounded-md"
                                    type="text"
                                />
                                <ErrorMessage name="address" component="p" className="text-red-500 text-xs" />
                            </div>
                        </div>

                        <div className="px-6 py-4">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                            >
                                {isSubmitting ? 'Menyimpan...' : 'Simpan Perusahaan'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>

            <hr/>
            {/* Form Social Media */}
            <Formik
                enableReinitialize
                initialValues={socialInitialValues}
                validationSchema={socialSchema}
                onSubmit={handleSocialSubmit}
            >
                {({ isSubmitting }) => (
                    <Form className="space-y-4">
                        <h2 className="text-xl font-bold px-6">Informasi Sosial Media</h2>
                        <div className="grid grid-cols-1 gap-4 px-6 py-2">
                            <div>
                                <label htmlFor="facebook">Facebook</label>
                                <Field
                                    name="facebook"
                                    className="my-2 p-2 w-full border border-gray-300 rounded-md"
                                    type="text"
                                />
                                <ErrorMessage name="facebook" component="p" className="text-red-500 text-xs" />
                            </div>
                            {/* <div>
                                <label htmlFor="facebook">Facebook</label>
                                <Field
                                    name="facebook"
                                    className="my-2 p-2 w-full border border-gray-300 rounded-md"
                                    type="url"
                                    placeholder="https://facebook.com/..."
                                />
                                <ErrorMessage name="facebook" component="p" className="text-red-500 text-xs" />
                            </div> */}

                            <div>
                                <label htmlFor="instagram">Instagram</label>
                                <Field
                                    name="instagram"
                                    className="my-2 p-2 w-full border border-gray-300 rounded-md"
                                    type="url"
                                    placeholder="https://instagram.com/..."
                                />
                                <ErrorMessage name="instagram" component="p" className="text-red-500 text-xs" />
                            </div>

                            <div>
                                <label htmlFor="whatsapp">WhatsApp</label>
                                <Field
                                    name="whatsapp"
                                    className="my-2 p-2 w-full border border-gray-300 rounded-md"
                                    type="text"
                                    placeholder="6281234567890"
                                />
                                <ErrorMessage name="whatsapp" component="p" className="text-red-500 text-xs" />
                            </div>
                        </div>

                        <div className="px-6 py-4">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
                            >
                                {isSubmitting ? 'Menyimpan...' : 'Simpan Sosial Media'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default EntryCompany;
